// /* eslint-disable no-unused-vars */
// import { useState, useEffect, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import "../assets/css/header.css";

// // Font Awesome
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faUser,
//   faBell,
//   faEnvelope,
//   faRightFromBracket,
// } from "@fortawesome/free-solid-svg-icons";

// export default function Header() {
//   const [menuOpen, setMenuOpen] = useState(false);
//   const navigate = useNavigate();
//   const [dateTime, setDateTime] = useState(new Date());

//   const timer = useRef(null);
//   const INACTIVITY_LIMIT = 5 * 60 * 1000; // 5 minutes

//   const handleLogout = () => {
//     // ✅ Clear login-related data
//     localStorage.clear();
//     sessionStorage.clear();

//     // ✅ Redirect to login
//     navigate("/login", { replace: true });

//     // ✅ Reload to reset app state completely
//     window.location.reload();
//   };

//   // Track user activity for auto logout
//   useEffect(() => {
//     const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];
//     events.forEach((event) => window.addEventListener(event, resetTimer));
//     resetTimer();

//     return () => {
//       events.forEach((event) =>
//         window.removeEventListener(event, resetTimer)
//       );
//       if (timer.current) clearTimeout(timer.current);
//     };
//   }, []);

//   useEffect(() => {
//     const interval = setInterval(() => setDateTime(new Date()), 1000);
//     return () => clearInterval(interval);
//   }, []);

//   const resetTimer = () => {
//     if (timer.current) clearTimeout(timer.current);
//     timer.current = setTimeout(handleLogout, INACTIVITY_LIMIT);
//   };

//   useEffect(() => {
//     // List of user activity events to track
//     const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];

//     // Attach event listeners
//     events.forEach((event) => window.addEventListener(event, resetTimer));

//     // Start the timer initially
//     resetTimer();

//     // Cleanup on unmount
//     return () => {
//       events.forEach((event) => window.removeEventListener(event, resetTimer));
//       if (timer.current) clearTimeout(timer.current);
//     };
//   }, []);

//   // / Format date and time
//   const day = dateTime.toLocaleDateString("en-US", { weekday: "long" });
//   const date = dateTime.getDate();
//   const month = dateTime.toLocaleDateString("en-US", { month: "long" });
//   const year = dateTime.getFullYear();
//   const time = dateTime.toLocaleTimeString([], {
//     hour: "2-digit",
//     minute: "2-digit",
//     second: "2-digit",
//   });

//   return (
//     <div className="header">
//        <div className="header-top">
//         <div className="header-date-time">
//           {day}, {month} {date}, {year} {time}
//         </div>
//         <div className="header-top-right">
//           <div id="google_translate_element"></div>
//           <div className="ip-label">
//             <span>Powered by </span>
//             <span className="ip-dot"></span>
//             <span> IP:</span>
//           </div>
//         </div>
//       </div>

//       <h1 className="header-title"></h1>

//       <div className="header-actions">
//         {/* Hamburger Menu for Small Screens */}
//         <button
//           className="hamburger-menu"
//           onClick={() => setMenuOpen(!menuOpen)}
//         >
//           ☰
//         </button>

//         {/* Navigation Buttons */}
//         <div className={`menu-buttons ${menuOpen ? "show" : ""}`}>
//           <button
//             className="header-button"
//             onClick={() => navigate("/Profile")}
//           >
//             <FontAwesomeIcon icon={faUser} /> Profile
//           </button>
//           <button
//             className="header-button"
//             onClick={() => navigate("/alerts")}
//           >
//             <FontAwesomeIcon icon={faBell} /> Alerts
//           </button>
//           <button
//             className="header-button"
//             onClick={() => navigate("/Branchmessage")}
//           >
//             <FontAwesomeIcon icon={faEnvelope} /> Message
//           </button>

//           <button className="header-button" onClick={handleLogout}>
//             <FontAwesomeIcon icon={faRightFromBracket} /> Logout
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

/* eslint-disable no-unused-vars */
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "../assets/css/header.css";

// Font Awesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faBell,
  faEnvelope,
  faRightFromBracket,
  faCalculator,
} from "@fortawesome/free-solid-svg-icons";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import { useDispatch, useSelector } from "react-redux";

export default function Header() {
  const dispatch = useDispatch();
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
 
  const [dateTime, setDateTime] = useState(new Date());
  // const timer = useRef(null);
  // const INACTIVITY_LIMIT = 5 * 60 * 1000; // 5 minutes

  // ✅ Auto logout on inactivity
  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate("/login", { replace: true });
    window.location.reload();
  };



  // const resetTimer = () => {
  //   if (timer.current) clearTimeout(timer.current);
  //   timer.current = setTimeout(handleLogout, INACTIVITY_LIMIT);
  // };

  // useEffect(() => {
  //   const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];
  //   events.forEach((event) => window.addEventListener(event, resetTimer));
  //   resetTimer();

  //   return () => {
  //     events.forEach((event) =>
  //       window.removeEventListener(event, resetTimer)
  //     );
  //     if (timer.current) clearTimeout(timer.current);
  //   };
  // }, []);

  // ✅ Update time every second
  useEffect(() => {
    const interval = setInterval(() => setDateTime(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  // ✅ Google Translate Integration
  useEffect(() => {
    const scriptId = "google-translate-script";
    if (!document.getElementById(scriptId)) {
      const addScript = document.createElement("script");
      addScript.id = scriptId;
      addScript.type = "text/javascript";
      addScript.src =
        "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      document.body.appendChild(addScript);
    }

    window.googleTranslateElementInit = () => {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: "en",
          includedLanguages: "en,hi,bn,gu,ta,te,ml,mr,kn,pa,ur",
          layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
        },
        "google_translate_element",
      );
    };
  }, []);

  // ✅ Format date and time
  const day = dateTime.toLocaleDateString("en-US", { weekday: "long" });
  const date = dateTime.getDate();
  const month = dateTime.toLocaleDateString("en-US", { month: "long" });
  const year = dateTime.getFullYear();
  const time = dateTime.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });

  

  return (
    <div className="header">
      {/* ✅ Header Top Section */}
      <div className="header-top">
        <div className="header-date-time">
          {day}, {month} {date}, {year} {time}
        </div>

        <div className="header-top-right">
          <div id="google_translate_element"></div>
          <div className="ip-label">
            {/* <span>Powered by </span>
            <span className="ip-dot"></span>
            <span> IP:</span> */}
          </div>
        </div>
      </div>

      {/* ✅ Header Bottom Section */}
      <div className="header-actions">
        {/* Hamburger Menu for Small Screens */}
        <div className="nav-header-title">
          <p>Branch Panel</p>
        </div>

        {/* Navigation Buttons */}
        <div className={`menu-buttons ${menuOpen ? "show" : ""}`}>
          <button
            className="header-button"
            onClick={() => navigate("/Profile")}
          >
            <FontAwesomeIcon icon={faUser} /> 
          </button>

          <button className="header-button" onClick={() => navigate("/Loan/EmiCalculator")}>
            <FontAwesomeIcon icon={faCalculator} /> 
          </button>

          <button className="header-button" onClick={() => navigate("/alerts")}>
            <FontAwesomeIcon icon={faBell} /> 
          </button>

          <button className="header-button" onClick={handleLogout}>
            <FontAwesomeIcon icon={faRightFromBracket} /> 
          </button>
        </div>
      </div>
    </div>
  );
}
